<!--
 * @Author:
 * @Description: 高级查询组件
-->
<template>
  <div>
    <el-dialog
      v-if="dialogVisible"
      :visible.sync="dialogVisible"
      title="高级查询"
      width="1220px"
      custom-class="advanced-queries-dialog"
      :close-on-click-modal="false"
      :modal-append-to-body="false"
      @close="closeDialog"
      v-dialogDrag
    >
      <el-table
        v-loading="tableLoading"
        :data="tableData"
        ref="table"
        height="480px"
        row-key="id"
        stripe
        border
      >
        <el-table-column label="属性编码" prop="code"></el-table-column>
        <el-table-column label="属性名称" prop="name"></el-table-column>
        <el-table-column label="条件规则">
          <template slot-scope="scope">
            <el-select v-model="scope.row.conditionalType" placeholder="请选择" clearable>
              <el-option
                v-for="item in symbolList"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              ></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="值" prop="value">
          <template slot-scope="scope">
            <div v-if="scope.row.conditionalType === 'Range'">
              <el-input
                class="w-2/5"
                v-model="scope.row.rangeValue1"
                placeholder="请输入"
              ></el-input>
              -
              <el-input
                class="w-2/5"
                v-model="scope.row.rangeValue2"
                placeholder="请输入"
              ></el-input>
            </div>
            <div v-else>
              <el-input v-model="scope.row.value" placeholder="请输入"></el-input>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">{{ $t('cancel') }}</el-button>
        <el-button type="primary" :loading="saveLoading" @click="submit">{{
          $t('save')
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import assetService from '@/services/assetService'

export default {
  name: 'advancedQueries',
  props: {
    advancedQueriesProps: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      dialogVisible: false,
      tableLoading: false,
      saveLoading: false,
      tableData: [],
      tableHeader: [],
      classId: '',
      symbolList: [
        { value: 'Like', name: '包含' },
        { value: 'Equal', name: '等于' },
        { value: 'Range', name: '介于之间' },
        { value: 'In', name: '存在' },
        { value: 'GreaterThan', name: '大于' },
        { value: 'LessThan', name: '小于' },
      ],
    }
  },
  watch: {
    advancedQueriesProps: {
      deep: true,
      immediate: true,
      async handler(val) {
        if (val) {
          // console.log(val, 'val')
          this.dialogVisible = val.dialogVisible
          if (val.classIds.length !== 1) {
            await this.getTypeClass()
          } else {
            this.classId = val.classIds[0]
          }
          if (val.dialogVisible) {
            this.getTableData()
          }
        }
      },
    },
  },
  created() {},
  methods: {
    // 获取文档实体id
    async getTypeClass() {
      const res = await assetService.getTypeClass({
        standardId: this.advancedQueriesProps.standardId,
        code: this.advancedQueriesProps.codeType,
      })
      if (res && res.code === 0 && res.data) {
        this.classId = res.data.id
      }
    },
    // 获取列表数据
    async getTableData() {
      const params = {
        classId: this.classId,
        skipCount: 0,
        maxResultCount: 999,
        sorting: '',
        nameOrCode: '',
      }
      this.tableLoading = true
      const res = await assetService.getClassAndClassTypeAttrDropDowData(params)
      this.tableLoading = false
      if (res && res.code === 0 && res.data) {
        this.tableData = res.data
      }
    },
    // 保存
    submit() {
      const conditionalModels = this.tableData.map((item) => {
        let fieldValue = item.value
        // 介于之间则用逗号隔开
        if (item.conditionalType === 'Range') {
          fieldValue = `${item.rangeValue1},${item.rangeValue2}`
        }
        return {
          fieldName: item.colName,
          fieldValue,
          conditionalType: item.conditionalType,
          valueType: item.valueType,
        }
      })
      this.$emit('updateAdvancedQueries', {
        dialogVisible: false,
        conditionalModels,
        classId: this.classId,
      })
    },
    // 关闭弹框
    closeDialog() {
      this.dialogVisible = false
      this.$emit('updateAdvancedQueries', { dialogVisible: false })
    },
  },
}
</script>

<style lang="scss" scoped>

</style>
